<div class="content">
  <div class="wrapper">
    <div class="header">
      <div class="title">
        <h1>Nos Tarifs</h1>
        <p>Choisissez le plan qui correspond à vos besoins</p>
      </div>
      <div class="buttons">
        <div class="group-button">
          <button [ngClass]="{'active': subscription_type.annual.enabled}" (click)="changeSubscriptionType(subscription_type.annual.value)">
            {{ subscription_type.annual.title }}
          </button>
          <button [ngClass]="{'active': subscription_type.monthly.enabled}" (click)="changeSubscriptionType(subscription_type.monthly.value)">
            {{ subscription_type.monthly.title }}
          </button>
        </div>
        <div class="icon-button">
          <i class="bi bi-x" (click)="onCloseDialog()"></i>
        </div>
      </div>
    </div>
    <div class="info">
      <i class="bi bi-question-circle"></i>
      <span>
        Économisez jusqu'à 20% avec un abonnement annuel
      </span>
    </div>
    <div class="plans">
      <div class="plan" *ngFor="let plan of plans" [ngClass]="{'popular': plan.popular.enabled}">
        <div class="popular-badge" *ngIf="plan.popular.enabled">
          {{plan.popular.title}}
        </div>
        <div class="header">
          <div class="title">{{plan.title}}</div>
          <div class="price" [ngClass]="{'price-enterprise': ['Enterprise', 'Starter'].includes(plan.title)}">{{plan.price}}</div>
          <div class="price-unit" *ngIf="['Pro'].includes(plan.title)" [ngStyle]="{'height': !plan.price_unit ? '10px' : ''}">{{plan.price_unit}}</div>
        </div>
        <div class="content">
          <div class="feature" *ngFor="let feature of plan.features">
            <div *ngIf="!feature?.is_starter">
              <img [src]="feature.icon" alt="">
            </div>
            <div class="ml-2" *ngIf="!feature?.is_starter">
              <div class="title">{{feature.title}}</div>
              <div class="description">{{feature.description}}</div>
            </div>

            <div *ngIf="feature?.is_starter" class="starter">
              {{ feature.description }}
            </div>
          </div>
        </div>
        <div class="plan-footer">
          <button class="btn btn-primary" [disabled]="plan.current" (click)="onSelectPlan(createOrganization, plan.title)">
            <img *ngIf="plan.btn_action?.icon" [src]="plan.btn_action?.icon" class="mr-2" alt="">
            {{ plan.current ? 'Current plan' : plan.btn_action.title}}
          </button>
        </div>
      </div>
    </div>

    <div class="footer">
      <div class="footer-content">
        Tous les prix sont en XOF (Franc CFA). La TVA peut s'appliquer selon votre pays.
      </div>
      <div class="footer-content-2">
        <span class="text">Besoin d'aide pour choisir ?</span>
        <span class="contact-us">Contactez-nous &nbsp;<svg xmlns="http://www.w3.org/2000/svg" width="15" height="16"
            viewBox="0 0 15 16" fill="none">
            <g clip-path="url(#clip0_138_6707)">
              <path
                d="M13.9875 8.70615C14.3781 8.31553 14.3781 7.68115 13.9875 7.29053L8.9875 2.29053C8.59688 1.8999 7.9625 1.8999 7.57188 2.29053C7.18125 2.68115 7.18125 3.31553 7.57188 3.70615L10.8687 6.9999H1.28125C0.728125 6.9999 0.28125 7.44678 0.28125 7.9999C0.28125 8.55303 0.728125 8.9999 1.28125 8.9999H10.8656L7.575 12.2937C7.18437 12.6843 7.18437 13.3187 7.575 13.7093C7.96562 14.0999 8.6 14.0999 8.99063 13.7093L13.9906 8.70928L13.9875 8.70615Z"
                fill="#1566E3" />
            </g>
            <defs>
              <clipPath id="clip0_138_6707">
                <path d="M0.28125 0H14.2812V16H0.28125V0Z" fill="white" />
              </clipPath>
            </defs>
          </svg></span>
      </div>
    </div>
  </div>
</div>

<ng-template #createOrganization>
  <div class="modal-body pt-4 px-4">
    <div class="d-flex justify-content-end mb-2">
      <i class="bi bi-x-lg dialog-close-icon" class="btn-close" style="font-size: 1rem !important"
        aria-label="Close" (click)="modalRef2?.hide()"></i>
    </div>
    <div class="msg-acc-form">
      <form [formGroup]="upgradeForm">
        <div class="row d-flex justify-content-center">
          <div class="col-md-12 col-sm-12">
            <div class="form-group mb-4">
              <!-- <label class="msg-acc-label">Organization Name<sup>*</sup></label> -->
              <input [autofocus]="true" formControlName="organizationName" style="border-radius: 2px; width: 100%; height: 40px; border: 1px solid #E5E7EB; padding: 0 16px;"
                placeholder="Give your organization a name." />
              <span *ngIf="upgradeForm.invalid && upgradeForm.value.organizationName !== ''" style="color: red;
                    display: flex;
                    flex-direction: row;
                    flex-wrap: nowrap;
                ">
                Can't contain uppercase letters or special characters.</span>
            </div>

            <div class="col-md-12 col-sm-12">
              <div class="d-flex justify-content-center">
                <button type="button" (click)="onSubmit()" [disabled]="upgradeForm.invalid || loading"
                  class="btn btn-primary submit">
                  <span>Create organization</span>
                  <span class="spinner-border text-white" style="font-size: 10px; height: 15px; width: 15px;"
                    role="status" *ngIf="loading">
                    <span class="sr-only">Loading...</span>
                  </span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</ng-template>